define('vspot-angular/services/login-service',[], function () {
    'use strict';

    return ['resources.Login', function (Login) {
        return {
            /*
             *  Copy an activity, possibly to a new date
             *
             *  @param {int}  activityId - Id of the activity to copy
             *  @param {str}  accessKey - Authentication key
             *  @param {str}  newActivityName - Name for new activity
             *  @param {str}  newStartDate - New start date
             *
             *  @returns  Resource object. See /resources.js documentation for details.
             *            Expected return data: { status: boolean, code: string, num_invitations: int }
             *            num_invitations: Number of invitations that the user has
             */
            copyActivity: function (activityId, accessKey, newActivityName, newStartDate, force) {
                if( global_helper.blank(force) ) {
                    force = false;
                }

                return Login.copyActivity({
                    startdate:  newStartDate,
                    newname:    newActivityName,
                    activity:   activityId,
                    accesskey:  accessKey,
                    force:      force
                });
            },

            /*
             *  transfer an activity
             *
             *  @param {int}  activityId - Id of the activity to copy
             *  @param {str}  accessKey - Authentication key
             *  @param {str}  newOrganizer - Email address of the new organizer
             *
             *  @returns  Resource object. See /resources.js documentation for details.
             *            Expected return data: { status: boolean, code: string, num_invitations: int }
             *            num_invitations: Number of invitations that the user has
             */
            transferActivity: function (activityId, accessKey, newOrganizer) {
                return Login.transferActivity({
                    neworganizer:   newOrganizer,
                    activity:       activityId,
                    accesskey:      accessKey
                });
            },

            /*
             *  Send an email for an custom premium request
             *
             *  @param {obj}  postData - the form data
             *
             *  @returns  Resource object.
             */
            emailSpecialRequestInquiry: function (postData) {
                return Login.emailSpecialRequestInquiry(postData);
            },

            /*
             *  Send an email for an special pricing request
             *
             *  @param {obj}  postData - the form data
             *
             *  @returns  Resource object.
             */
            emailSpecialPricingInquiry: function (postData) {
                return Login.emailSpecialPricingInquiry(postData);
            },

            /*
             *  Send an email for an advertising request
             *
             *  @param {obj}  postData - the form data
             *
             *  @returns  Resource object.
             */
            emailAdvertisingRequest: function (postData) {
                return Login.emailAdvertisingRequest(postData);
            },
            
            emailClientFeedback: function (postData) {
                return Login.emailClientFeedback(postData);
            },

            emailGeneralFeedback: function (postData) {
                return Login.emailGeneralFeedback(postData);
            },

            emailImageFlag: function (postData) {
                return Login.emailImageFlag(postData);
            },

            submitContactFormInfo: function (postData) {
                return Login.submitContactFormInfo(postData);
            },

            submitContactFormSupport: function (postData) {
                return Login.submitContactFormSupport(postData);
            },

            submitContactFormAdvertising: function (postData) {
                return Login.submitContactFormAdvertising(postData);
            },

            /*
             *  Submit the Premium Registration form
             *
             *  @param {obj}  postData - the form data
             *
             *  @returns  Resource object.
             */
            stripePremiumReg: function (postData) {
                return Login.stripePremiumReg(postData);
            },

            /*
             *  Volunteer is authenticating with the server. Sets up the correct
             *      session variables.
             *  NOTE: the accesskey isn't on the volunteer object, it's outside it,
             *  so we insert it in the volunteer object to facilitate passing
             *  the object around more easily.
             *
             *  @param {obj}  postData - the form data
             *
             *  @returns  Resource object.
             */
            handleEntry: function (email, activityId, isDesktop) {
                var resource = Login.handleEntry({
                    email:          email,
                    activity_id:    activityId,
                    is_desktop:     isDesktop
                });

                resource.$promise.then(function (result) {
                    if (result.status) {
                        // Insert the access key in the volunteer object so it gets passed around successfully
                        result.volunteer.accessKey = result.accesskey;
                    }
                });

                return resource;
            },

            /*
             * logout:
             * Log the user out, and end the session.
             */
            logout: function() {
                return Login.logout();
            }
        };
    }];
});

